import { useEffect, useState } from "react";

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mql = window.matchMedia(query);
    const handleChange = (event) => setMatches(event.matches);
    mql.addEventListener("change", handleChange);
    setMatches(mql.matches);
    return () => mql.removeEventListener("change", handleChange);
  }, [query]);

  return matches;
}
